const Menu = () => {
  return (
    <ul id='menu' className='menuList'>
      <li>
        <a className='menuLink' href='#menu'>
          Menu
        </a>
        <div className='menuArrow arrow'></div>
        <ul className='subMenuList'>
          <li>
            <a className='subMenuLink' href='#brief-description-nav'>
              Brief description
            </a>
            <div className='subMenuArrow arrow'></div>
            <ul className='subSubMenuList'>
              <li>
                <a className='subSubMenuLink' href='#citrine'>
                  Citrine
                </a>
              </li>
              <li>
                <a className='subSubMenuLink' href='#chrysolite'>
                  Chrysolite
                </a>
              </li>
              <li>
                <a className='subSubMenuLink' href='#sapphire'>
                  Sapphire
                </a>
              </li>
              <li>
                <a className='subSubMenuLink' href='#amethyst'>
                  Amethyst
                </a>
              </li>
              <li>
                <a className='subSubMenuLink' href='#ruby'>
                  Ruby
                </a>
              </li>
            </ul>
          </li>
          <li>
            <a className='subMenuLink' href='#gallery'>
              Gallery
            </a>
            <div className='subMenuArrow arrow'></div>
          </li>
          <li>
            <a className='subMenuLink' href='#form'>
              Form
            </a>
            <div className='subMenuArrow arrow'></div>
          </li>
        </ul>
      </li>
    </ul>
  );
};

export default Menu;
